import React from "react";

export default function Quantity({ item, qty, updateQty }) {

    return (
        <div className="inline-block border border-secondary rounded-full overflow-hidden shadow-lg">
            <button className="py-2 px-3 leading-none hover:bg-secondary hover:text-white" aria-label="Reduce quantity" onClick={(e) => updateQty(e, item, -1)}>-</button>
            <span className="inline-block text-center w-8">{qty}</span>
            <button className="py-2 px-3 leading-none hover:bg-secondary hover:text-white" aria-label="Increase quantity" onClick={(e) => updateQty(e, item, 1)}>+</button>
        </div>
    )
}